module.exports = __webpack_public_path__ + "static/media/Sion.ad52afc1.png";